var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3714 12.1857C24.3714 14.8748 23.4985 17.3588 22.028 19.3741L29.4449 26.7969C30.1772 27.5292 30.1772 28.7184 29.4449 29.4508C28.7126 30.1831 27.5233 30.1831 26.791 29.4508L19.3741 22.028C17.3588 23.5044 14.8748 24.3714 12.1857 24.3714C5.45428 24.3714 0 18.9172 0 12.1857C0 5.45428 5.45428 0 12.1857 0C18.9172 0 24.3714 5.45428 24.3714 12.1857ZM12.1857 20.622C13.2936 20.622 14.3906 20.4038 15.4141 19.9798C16.4377 19.5558 17.3677 18.9344 18.1511 18.1511C18.9344 17.3677 19.5558 16.4377 19.9798 15.4141C20.4038 14.3906 20.622 13.2936 20.622 12.1857C20.622 11.0778 20.4038 9.98083 19.9798 8.9573C19.5558 7.93376 18.9344 7.00375 18.1511 6.22038C17.3677 5.437 16.4377 4.81559 15.4141 4.39162C14.3906 3.96766 13.2936 3.74945 12.1857 3.74945C11.0778 3.74945 9.98083 3.96766 8.9573 4.39162C7.93376 4.81559 7.00375 5.437 6.22038 6.22038C5.437 7.00375 4.81558 7.93376 4.39162 8.9573C3.96766 9.98083 3.74945 11.0778 3.74945 12.1857C3.74945 13.2936 3.96766 14.3906 4.39162 15.4141C4.81558 16.4377 5.437 17.3677 6.22038 18.1511C7.00375 18.9344 7.93376 19.5558 8.9573 19.9798C9.98083 20.4038 11.0778 20.622 12.1857 20.622Z",
    fill: "#FFE769"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.8d580916340b899198cde3d7b5b93ce5.svg";
export { ForwardRef as ReactComponent };